// Chain configuration: Stellar Testnet only (non-EVM; not used with MetaMask chain switching)
/** Stellar Lab “Fund account” (testnet XLM / assets). */
export const STELLAR_LAB_FUND_ACCOUNT_URL = 'https://lab.stellar.org/account/fund';

export const CHAINS = {
    stellar: {
        id: 'stellar',
        name: 'Stellar Testnet',
        symbol: 'XLM',
        chainId: '0x0',
        chainIdDecimal: 0,
        // Soroban JSON-RPC (primary for contract calls)
        rpcUrl: process.env.REACT_APP_STELLAR_SOROBAN_RPC_URL || 'https://soroban-testnet.stellar.org',
        horizonUrl: process.env.REACT_APP_STELLAR_HORIZON_URL || 'https://horizon-testnet.stellar.org',
        networkPassphrase:
            process.env.REACT_APP_STELLAR_NETWORK_PASSPHRASE || 'Test SDF Network ; September 2015',
        blockExplorerUrl:
            process.env.REACT_APP_STELLAR_BLOCK_EXPLORER || 'https://stellar.expert/explorer/testnet',
        nativeCurrency: {
            name: 'Lumen',
            symbol: 'XLM',
            decimals: 7,
        },
        icon: '/stellar.png',
        color: '#7D00FF',
        active: true,
        // Stellar Wallets Kit: when false, Freighter + Hana + xBull + Lobstr are registered and shown.
        // Set REACT_APP_STELLAR_WALLET_KIT_FULL_CATALOG=true to enable the kit's full default wallet set.
        walletKitFullCatalog:
            String(process.env.REACT_APP_STELLAR_WALLET_KIT_FULL_CATALOG || '').toLowerCase() === 'true',
        // Prefilled when the user clicks "demo account" on the transfer form
        demoTransferRecipient:
            process.env.REACT_APP_STELLAR_DEMO_TRANSFER_RECIPIENT ||
            'GDBE3I3WZKZB6AFIACF4SIODH7AQOPTG5YRUCRKTISOSBMP326BUJ7VP',
        // Confidential Stabletrust / gateway contract on Soroban testnet — override with REACT_APP_STELLAR_CONTRACT_ADDRESS if needed
        contractAddress:
            process.env.REACT_APP_STELLAR_CONTRACT_ADDRESS ||
            'CDTFREQO7URZD6QASSKZASOGEZZZWBJ5ELPAG3MYEWNSMDX5RASR4PZV',
        tokens: {
          
            usdc: {
                address:
                    process.env.REACT_APP_STELLAR_USDC_CONTRACT_ID ||
                    'CBIELTK6YBZJU5UP2WWQEUCYKLPU6AUNZ2BQ4WWFEIE3USCIHMXQDAMA',
                decimals: Number(process.env.REACT_APP_STELLAR_USDC_DECIMALS) || 7,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA',
            },
            // EURC: Circle testnet asset EURC-GB3Q6QDZYTHWT7E5PVS3W7FUT5GVAFC5KSZFFLPU25GO7VTC3NM2ZTVO → SAC (Horizon contract_id). Do not use unrelated pool/faucet contract IDs.
            eurc: {
                address:
                    process.env.REACT_APP_STELLAR_EURC_CONTRACT_ID ||
                    'CCUUDM434BMZMYWYDITHFXHDMIVTGGD6T2I5UKNX5BSLXLW7HVR4MCGZ',
                decimals: Number(process.env.REACT_APP_STELLAR_EURC_DECIMALS) || 7,
                symbol: 'EURC',
                name: 'Euro Coin',
                icon: process.env.REACT_APP_STELLAR_EURC_ICON_URL || '/eurc.png',
                color: '#003399',
            },
            // Soroban USDT on testnet: set REACT_APP_STELLAR_USDT_CONTRACT_ID when you have a deployed SAC; omitted from UI if unset
            usdt: {
                address: process.env.REACT_APP_STELLAR_USDT_CONTRACT_ID || '',
                decimals: Number(process.env.REACT_APP_STELLAR_USDT_DECIMALS) || 7,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/tablogo.svg',
                color: '#26A17B',
            },
            // Native XLM as Soroban Stellar Asset Contract (SEP-41) on testnet (Soroswap faucet list)
            xlm: {
                address:
                    process.env.REACT_APP_STELLAR_XLM_SAC_CONTRACT_ID ||
                    'CDLZFC3SYJYDZT7K67VZ75HPJVIEUVNIXF47ZG2FB2RMQQVU2HHGCYSC',
                decimals: Number(process.env.REACT_APP_STELLAR_XLM_DECIMALS) || 7,
                symbol: 'XLM',
                name: 'Stellar Lumens',
                icon: process.env.REACT_APP_STELLAR_XLM_ICON_URL || '/stellar.png',
                color: '#7D00FF',
            },
        },
    },
};

export const getActiveChains = () => {
    return Object.values(CHAINS).filter((chain) => chain.active);
};

export const getChainById = (chainId) => {
    return Object.values(CHAINS).find(
        (chain) => chain.chainId === chainId || chain.chainIdDecimal === chainId || chain.id === chainId
    );
};

export const getPopularChains = () => {
    const chainOrder = ['stellar'];
    return chainOrder.map((id) => CHAINS[id]).filter(Boolean);
};

export const getAllTokens = () => {
    const allTokens = {};
    Object.values(CHAINS).forEach((chain) => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            const key = `${chain.id}_${tokenId}`;
            allTokens[key] = {
                ...token,
                chainId: chain.id,
                chainName: chain.name,
                chainIcon: chain.icon,
                chainColor: chain.color,
            };
        });
    });
    return allTokens;
};

export const getPopularTokens = () => {
    const popularTokenSymbols = ['USDC', 'EURC', 'XLM', 'USDT', 'DAI', 'USDG'];
    const popularTokens = [];

    Object.values(CHAINS).forEach((chain) => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            if (popularTokenSymbols.includes(token.symbol)) {
                popularTokens.push({
                    ...token,
                    id: `${chain.id}_${tokenId}`,
                    chainId: chain.id,
                    chainName: chain.name,
                    chainIcon: chain.icon,
                    chainColor: chain.color,
                    chainActive: chain.active,
                });
            }
        });
    });

    return popularTokens;
};
